import { IDriveViewBulkDownloadResult } from '@commenda/types/src/drive-view/types';
import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IBulkDownloadFilePlacementsParams {
  filePlacementIds?: string[];
  folderIds?: string[];
}

export async function bulkDownloadFilePlacements({
  filePlacementIds,
  folderIds,
}: IBulkDownloadFilePlacementsParams): Promise<
  IApiResponse<IDriveViewBulkDownloadResult>
> {
  const response = await fetcher('drive-view/file-placement/download/bulk', {
    method: 'POST',
    body: { filePlacementIds, folderIds },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to download files',
      statusCode: response.status,
      data: null,
    };
  }

  const body = await response.json();
  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: body.download as IDriveViewBulkDownloadResult,
  };
}
